import { RewardType } from '@betty/rewards';
import { RewardsTextConfig } from './RewardsText.types';

export const REWARD_TEXT_CONFIG: RewardsTextConfig = {
  [RewardType.FreeSpins]: {
    icon: 'freeSpins',
    text: 'freeSpins',
  },
  [RewardType.Coins]: {
    icon: 'bettyCoin',
    text: 'bettyCoins',
  },
  [RewardType.InstantWheel]: {
    icon: 'rewardWheel',
    text: 'wheelSpins',
  },
  [RewardType.Cash]: {
    icon: 'bettyDollar',
  },
};
